import { DoctorStory } from '@/modules/JobListing/utils/JobListingTypes';
import { ITestimonial } from 'types/cms';

const buildAvatarImageUrl = (testimonial: ITestimonial): string | undefined =>
  testimonial.image?.formats?.thumbnail?.url ?? testimonial.image?.url;

/**
 * Maps a CMS testimonial onto the DoctorStoryCard display shape. CMS testimonials have no
 * rating field - every testimonial published is assumed to be a positive one, matching how
 * every hand-authored static doctor story is also a flat 5 stars.
 *
 * No highlight tag (tagLabel/tagVariant) is derived from `category`/`subcategory` - those fields
 * hold internal audience labels and raw comma-separated tag lists (e.g. "MR_Doctor", "AU,
 * Sydney"), not curated user-facing copy, so rendering them verbatim in the pill would leak
 * internal taxonomy onto public job listing pages. The tag is already optional on DoctorStory.
 */
export const testimonialToDoctorStory = (testimonial: ITestimonial): DoctorStory => ({
  id: String(testimonial.id),
  rating: 5,
  quote: testimonial.quote,
  authorName: testimonial.author_name ?? '',
  authorRole: testimonial.job_title ?? '',
  avatarImageUrl: buildAvatarImageUrl(testimonial),
});
